import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import { applyMiddleware, compose, createStore } from 'redux';
import mainReducer from '../src/reducers/rootReducer'
import persistStore from 'redux-persist/es/persistStore';
import thunk from 'redux-thunk';
import { PersistGate } from 'redux-persist/integration/react';
const store = createStore(mainReducer, applyMiddleware(thunk));
const persistor = persistStore(store);




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
